import { cva } from "@-/com.npmjs.cva";

/**
 * The website's content column; every page aligns its content to it. Use it directly for elements
 * that must be the column themselves (the main navigation, a horizontally scrolling strip) rather
 * than sit inside a `WebsiteContainer`.
 */
export const websiteContainerVariants = cva({
  base: "mx-auto w-full max-w-[76rem] px-5 sm:px-8 lg:px-10",
});
